import { AccessModeSelection } from 'components/AccessModeSelection'
import { SideBar } from 'components/Sidebar/sideBar'
import { AppContext } from 'contexts/AppContext'
import { Spinner } from 'keep-react'
import { useContext } from 'react'
import { Outlet } from 'react-router-dom'

export const ProtectedRoute = () => {
  const { showAccessMode, settings, isCallingApi } = useContext(AppContext)

  return (
    <div className="w-full">
      <div className="w-full relative">
        <div className="grid grid-cols-1 lg:grid-cols-[250px_1fr] h-[calc(100vh-85px)] overflow-y-hidden relative">
          <div className="hidden w-full lg:block z-30 h-full max-h-[calc(100vh-85px)">
            <SideBar />
          </div>
          <div className="max-h-[calc(100vh-112px)] overflow-y-auto w-full">
            <Outlet />
          </div>
        </div>
      </div>
      <div className="fixed top-[85%] right-0 z-[1000] w-[81px] h-[114px]">
        <a
          className="block w-[81px] h-[114px]"
          href={`tel:${settings?.phoneForContacts || ''}`}
        >
          <img src="/images/lets_talk.png" alt="" />
        </a>
      </div>
      {showAccessMode && <AccessModeSelection />}
      {isCallingApi && (
        <div className="fixed inset-0 bg-white bg-opacity-80 flex items-center justify-center z-[1000]">
          <div className="text-black text-xxxl font-bold flex items-center gap-4">
            <Spinner />
            Estamos a processar o seu pedido...
          </div>
        </div>
      )}
    </div>
  )
}
